import { getLocation } from './nuxtAdapter';

export type Area = 'cn' | 'us'; // 区域

export const PURE_HOST = [
  /jmjuntu.com/,
  /mfai.lzdxedu.com/,
  /3dvirtualhuman.com/,
  /test-youyan30-public.xmov.ai/,
  /test-public.youyan3d.com/,
  /mfai-test.lzdxedu.com/,
];

export const IFRAME_HOST = [/youyan3d.magook.com/, /youyan3d.bookan.com.cn/];

// 判断是否iframe嵌套的域名
export const isIframeHost = (host?: string): boolean => {
  return IFRAME_HOST.some(item => item.test(host || getLocation().host));
};

// 判断是否为纯净版
export const isPureHost = (host?: string): boolean => {
  const url = getLocation();
  return PURE_HOST.some(item => item.test(host || url.host)) || url.search.includes('pure=1');
};

// 获取当前区域
export const getArea = (): Area => {
  const area = getEnvConfig().AREA;
  // 处理环境变量中的大写值，转换为小写
  return (area?.toLowerCase() as Area) || 'cn';
};

// 获取版本号
export const getVersion = (): string => {
  return import.meta.env.VERSION || '1.0.0';
};

// 判断是否为国内版
export const isCN = (): boolean => {
  return getArea() === 'cn';
};

// 判断是否为海外版
export const isUS = (): boolean => {
  return getArea() === 'us';
};

// 获取全局配置
export const getGlobalConfig = () => {
  return {
    area: getArea(),
    version: getVersion(),
    isCN: isCN(),
    isUS: isUS(),
  };
};

const getEnvConfig = () => {
  return window?.ENV_CONFIG || import.meta.env || {};
};

// 根据区域获取不同的配置
export const getAreaConfig = () => {
  const area = getArea();

  // @ts-ignore
  const requestUrl = getLocation().origin;

  const globalConfig = getEnvConfig();

  const configs: Record<
    string,
    {
      area: Area;
      apiBaseUrl: string;
      cdnBaseUrl: string;
      defaultLocale: 'zh-CN' | 'en-US';
      timezone: string;
      wsMessageCenter: string;
      apiMessageCenter: string;
      feOss: string;
      beOss: string;
      domain: string;
      workspaceDomain: string;
      env: string;
    }
  > = {
    cn: {
      area: 'cn',
      apiBaseUrl: globalConfig?.API_BASE || '',
      cdnBaseUrl: globalConfig?.FE_OSS || '',
      defaultLocale: 'zh-CN',
      timezone: 'Asia/Shanghai',
      wsMessageCenter: globalConfig?.WS_MESSAGE_CENTER || '',
      apiMessageCenter: globalConfig?.API_MESSAGE_CENTER || '',
      feOss: globalConfig?.FE_OSS || '',
      beOss: globalConfig?.BE_OSS || '',
      domain: (isPureHost() ? requestUrl : globalConfig?.API_DOMAIN || '') || '/',
      workspaceDomain: globalConfig?.WORKSPACE_DOMAIN || '',
      env: globalConfig?.ENV || '',
    },
    us: {
      area: 'us',
      apiBaseUrl: globalConfig?.API_BASE || '',
      cdnBaseUrl: globalConfig?.FE_OSS || '',
      defaultLocale: 'en-US',
      timezone: 'America/New_York',
      wsMessageCenter: globalConfig?.WS_MESSAGE_CENTER || '',
      apiMessageCenter: globalConfig?.API_MESSAGE_CENTER || '',
      feOss: globalConfig?.FE_OSS || '',
      beOss: globalConfig?.BE_OSS || '',
      domain: (isPureHost() ? requestUrl : globalConfig?.API_DOMAIN || '') || '/',
      workspaceDomain: globalConfig?.WORKSPACE_DOMAIN || '',
      env: globalConfig?.ENV || '',
    },
  };

  return configs[area] || configs.cn;
};

// 设置全局配置
export const setupGlobalConfig = () => {
  const config = getGlobalConfig();
  (window as any).__GLOBAL_CONFIG__ = config;
};

export const isPrivate = () => {
  return getAreaConfig().env === 'private';
};

// 任务中心 channel
export const YY_COMMON_GENERATE_LIST = 'yy_common_generate_list';
